/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_CloseInputs */



/**
* | output |
* | --- |
* | "Close chat" |
*
* @param {Chat_CloseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_close = /** @type {((inputs?: Chat_CloseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_CloseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sluit chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer le chat")
	return /** @type {LocalizedString} */ ("Close chat")
});